module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/contents/noimage_s72x30-236d34bc5eb9785f6433e10fb2bfd87d.png";